import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LeadService } from 'src/app/private/services/lead.service';
import { UsersService } from 'src/app/private/services/users.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

const today = new Date();
const day = 24 * 60 * 60 * 1000; // one day in milliseconds
const startOfWeek = (date: Date) => {
  const d = new Date(date);
  const diff = d.getDate() - d.getDay(); // Sunday as start of week
  return new Date(d.setDate(diff));
};
const endOfWeek = (date: Date) => {
  const d = startOfWeek(date);
  return new Date(d.getTime() + 6 * day);
};
const startOfMonth = (date: Date) => new Date(date.getFullYear(), date.getMonth(), 1);
const endOfMonth = (date: Date) => new Date(date.getFullYear(), date.getMonth() + 1, 0);
const startOfQuarter = (date: Date) => new Date(date.getFullYear(), Math.floor(date.getMonth() / 3) * 3, 1);
const endOfQuarter = (date: Date) => new Date(date.getFullYear(), Math.floor(date.getMonth() / 3) * 3 + 3, 0);
const startOfYear = (date: Date) => new Date(date.getFullYear(), 0, 1);
const endOfYear = (date: Date) => new Date(date.getFullYear(), 11, 31);

const addDays = (date: Date, days: number) => new Date(date.getTime() + days * day);

@Component({
  selector: 'app-lead-report-details',
  imports: [SharedModule],
  templateUrl: './lead-report-details.component.html',
  styleUrl: './lead-report-details.component.scss'
})
export class LeadReportDetailsComponent {
  title = '';
  slug = '';
  dataSource: any[] = [];
  totalRows = 0;
  rows = 10;

  // Loading states
  initialLoad = true;
  isDataLoading = false;
  filterLoading = false;

  // Filter sidebar
  isOpen = false;

  // Filters


  todaysFilter = [
    {
      label: "Today",
      value: "today",
      start_date: new Date(today.setHours(0, 0, 0, 0)),
      end_date: new Date(new Date().setHours(23, 59, 59, 999))
    },
    {
      label: "Yesterday",
      value: "yesterday",
      start_date: new Date(addDays(new Date(), -1).setHours(0, 0, 0, 0)),
      end_date: new Date(addDays(new Date(), -1).setHours(23, 59, 59, 999))
    },
    {
      label: "Last 3 Days",
      value: "last_3_days",
      start_date: new Date(addDays(new Date(), -2).setHours(0, 0, 0, 0)),
      end_date: new Date(new Date().setHours(23, 59, 59, 999))
    },
    {
      label: "Last 7 Days",
      value: "last_7_days",
      start_date: new Date(addDays(new Date(), -6).setHours(0, 0, 0, 0)),
      end_date: new Date(new Date().setHours(23, 59, 59, 999))
    },
    {
      label: "Last 14 Days",
      value: "last_14_days",
      start_date: new Date(addDays(new Date(), -13).setHours(0, 0, 0, 0)),
      end_date: new Date(new Date().setHours(23, 59, 59, 999))
    },
    {
      label: "Last 21 Days",
      value: "last_21_days",
      start_date: new Date(addDays(new Date(), -20).setHours(0, 0, 0, 0)),
      end_date: new Date(new Date().setHours(23, 59, 59, 999))
    },
    {
      label: "Last 30 Days",
      value: "last_30_days",
      start_date: new Date(addDays(new Date(), -29).setHours(0, 0, 0, 0)),
      end_date: new Date(new Date().setHours(23, 59, 59, 999))
    },
    {
      label: "This Week",
      value: "this_week",
      start_date: new Date(startOfWeek(new Date()).setHours(0, 0, 0, 0)),
      end_date: new Date(endOfWeek(new Date()).setHours(23, 59, 59, 999))
    },
    {
      label: "Last Week",
      value: "last_week",
      start_date: new Date(addDays(startOfWeek(new Date()), -7).setHours(0, 0, 0, 0)),
      end_date: new Date(addDays(endOfWeek(new Date()), -7).setHours(23, 59, 59, 999))
    },
    {
      label: "This Quarter",
      value: "this_quarter",
      start_date: new Date(startOfQuarter(new Date()).setHours(0, 0, 0, 0)),
      end_date: new Date(endOfQuarter(new Date()).setHours(23, 59, 59, 999))
    },
    {
      label: "Last Quarter",
      value: "last_quarter",
      start_date: new Date(addDays(startOfQuarter(new Date()), -90).setHours(0, 0, 0, 0)),
      end_date: new Date(addDays(startOfQuarter(new Date()), -1).setHours(23, 59, 59, 999))
    },
    {
      label: "This Month",
      value: "this_month",
      start_date: new Date(startOfMonth(new Date()).setHours(0, 0, 0, 0)),
      end_date: new Date(endOfMonth(new Date()).setHours(23, 59, 59, 999))
    },
    {
      label: "Last Month",
      value: "last_month",
      start_date: new Date(new Date(today.getFullYear(), today.getMonth() - 1, 1).setHours(0, 0, 0, 0)),
      end_date: new Date(new Date(today.getFullYear(), today.getMonth(), 0).setHours(23, 59, 59, 999))
    },
    {
      label: "This Year",
      value: "this_year",
      start_date: new Date(startOfYear(new Date()).setHours(0, 0, 0, 0)),
      end_date: new Date(endOfYear(new Date()).setHours(23, 59, 59, 999))
    },
    {
      label: "Last Year",
      value: "last_year",
      start_date: new Date(new Date(today.getFullYear() - 1, 0, 1).setHours(0, 0, 0, 0)),
      end_date: new Date(new Date(today.getFullYear() - 1, 11, 31).setHours(23, 59, 59, 999))
    }
  ];

  leadStatusList: any[] = [
    { value: 'Assigned', label: 'Assigned' },
    { value: 'Working', label: 'Working' },
    { value: 'Qualified', label: 'Qualified' },
    { value: 'Raw', label: 'Raw' },
    { value: 'Unqualified', label: 'Unqualified' },
  ]

  leadSourceList: any[] = [
    { label: 'Channel Partner', value: 'Channel Partner' },
    { label: 'Conference', value: 'Conference' },
    { label: 'Field Visit', value: 'Field Visit' },
    { label: 'Google', value: 'Google' },
    { label: 'Instagram', value: 'Instagram' },
    { label: 'Lead Gen Tools', value: 'Lead Gen Tools' },
    { label: 'Live Session', value: 'Live Session' },
    { label: 'Personal', value: 'Personal' },
    { label: 'Referral', value: 'Referral' },
    { label: 'LinkedIn', value: 'LinkedIn' },
    { label: 'Website', value: 'Website' },
    { label: 'WhatsApp', value: 'WhatsApp' },
    { label: 'Tina', value: 'Tina' },
    { label: 'Intern', value: 'Intern' },
    { label: 'Other', value: 'Other' }
  ];


  selectedTodayFilter: string = 'today';

  leadOwnerList: any[] = [];

  selectedLeadOwnerFilter: any[] = [{
    user_id: this.localStorage.getUserId(),
    name: this.localStorage.getUserFullName()
  }];

  selectedLeadStatusFilter: any[] = [{
    value: 'Assigned',
    label: 'Assigned'
  }];

  selectedLeadSourceFilter: any[] = [{
    value: 'Tina',
    label: 'Tina'
  }];

  startDate: any = new Date(new Date().setHours(0, 0, 0, 0));
  endDate: any = new Date(new Date().setHours(23, 59, 59, 999));

  isAdmin: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private leadService: LeadService,
    private localStorage: LocalStorageService,
    private userService: UsersService,
  ) {
    this.slug = this.route.snapshot.paramMap.get('slug') || '';
    this.selectedTodayFilter = 'today'
  }


  loadData(event: any) {
    const page = (event.first / event.rows) * event.rows;
    const size = event.rows;
    switch (this.slug) {
      case 'todays-leads':
        this.title = "Today's Leads";
        this.getTodaysLeads(page, size);
        break;
      case 'leads-by-status':
        this.title = "Leads by Status";
        this.getLeadsByStatus(page, size);
        break;
      case 'leads-by-source':
        this.title = "Leads by Source";
        this.getLeadsBySource(page, size);
        break;
      case 'leads-by-ownership':
        this.title = "Leads by Ownership";
        this.getLeadsByOwnership(page, size);
        this.getAllLeadOwners();
        break;
      case 'qualified-leads':
        this.title = "Qualified Leads";
        this.getQualifiedLeads(page, size);
        break;
      case 'call-log-report':
        this.title = "Call Log Report";
        this.getAllLeadOwners();
        this.getCallLogReport(page, size);
        break;
      case 'email-log-report':
        this.title = "Email Log Report";
        this.getAllLeadOwners();
        this.getEmailLogReport(page, size);
        break;
      default:
        this.title = "Report Details";
        this.fetchData(page, size, this.getFilterParams());
    }
  }

  fetchData(page: number, size: number, filters: any): void {
    this.isDataLoading = true;
    this.leadService.getLeadReportDetails(this.slug).subscribe({
      next: (res: any) => {
        this.dataSource = res.data;
        this.totalRows = res.total;
        this.isDataLoading = false;
        this.initialLoad = false;
      },
      error: () => {
        this.isDataLoading = false;
        this.initialLoad = false;
      }
    });
  }

  getAllLeadOwners() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
    };
    this.userService.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.leadOwnerList = res || [];
        this.leadOwnerList = this.leadOwnerList.map((user: any) => {
          return {
            name: user.fname + " " + user.lname,
            user_id: user?.user_id
          };
        });
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }

  getFilterParams(): any {
    const params: any = {};
    if (this.slug === 'todays-leads' || this.slug === 'call-log-report' || this.slug === 'email-log-report') {
      params.todayFilter = this.selectedTodayFilter;
    }
    if (this.slug === 'leads-by-status') {
      params.statusList = this.selectedLeadStatusFilter;
    }
    return params;
  }

  openBulkFilter(): void {
    this.isOpen = true;
  }

  applyBulkFilter(): void {
    this.filterLoading = true;
    this.loadData({
      first: 0,
      rows: this.rows
    });
  }

  // Helpers
  getOwnerName(user: any): string {
    return [user.fname, user.lname].filter(Boolean).join(' ') || 'N/A';
  }

  isSourceImage(source: string): any {
    return source && (source.endsWith('.png') || source.endsWith('.jpg') || source.endsWith('.jpeg') || source.includes('/assets/'));
  }

  getLeadSourceImg(source: string) {
    if (source == 'tina') {
      source = 'Tina'
    } else if (source == 'whatsapp') {
      source = 'WhatsApp'
    } else if (source == 'manual') {
      source = 'Manual'
    }
    return `/assets/images/${source}.png`;
  }

  getStatusColor(status: string): string {
    switch (status) {
      case 'Qualified': return '#1FAF38';
      case 'Working': return '#F0950C';
      case 'Unqualified': return '#D74843';
      case 'Raw': return '#F0950C';
      default: return '#1FAF38'
    }
  }



  onTodayFilterChange(event: any): void {
    console.log(event);
    this.startDate = this.todaysFilter.find(filter => filter.value === event)?.start_date;
    this.endDate = this.todaysFilter.find(filter => filter.value === event)?.end_date;

    console.log(this.startDate, this.endDate);

  }

  getTodaysLeads(currentPage: number, rows: number): void {
    this.isDataLoading = true;

    let param: any = {
      where: {
        organization_id: this.localStorage.getOrganizationId(),
        campus_id: this.localStorage.getCampusId()
      },
      page: currentPage,
      limit: rows,
      startDate: this.startDate,
      endDate: this.endDate,
      order: {
        order: "updatedAt",
        dir: 'DESC',
      },
    };

    if (!this.isAdmin) {
      param.where.user_id = this.localStorage.getUserId();
    }

    this.leadService.getAllLeads(param).subscribe({
      next: (res: any) => {
        this.dataSource = res.rows;
        this.totalRows = res.count;
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      },
      error: () => {
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      }
    });
  }

  getLeadsByStatus(currentPage: number, rows: number): void {
    this.isDataLoading = true;
    let selectedStatusVal = this.selectedLeadStatusFilter.map((status: any) => status.value);
    let param: any = {
      where: {
        organization_id: this.localStorage.getOrganizationId(),
        campus_id: this.localStorage.getCampusId(),
        lead_status: selectedStatusVal
      },
      page: currentPage,
      limit: rows,
      order: {
        order: "updatedAt",
        dir: 'DESC',
      },
    };

    if (!this.isAdmin) {
      param.where.user_id = this.localStorage.getUserId();
    }

    this.leadService.getAllLeads(param).subscribe({
      next: (res: any) => {
        this.dataSource = res.rows;
        this.totalRows = res.count;
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      },
      error: () => {
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      }
    });
  }

  getLeadsBySource(currentPage: number, rows: number): void {
    this.isDataLoading = true;
    let selectedSourceVal = this.selectedLeadSourceFilter.map((source: any) => source.value);
    let param: any = {
      where: {
        organization_id: this.localStorage.getOrganizationId(),
        campus_id: this.localStorage.getCampusId(),
        source: selectedSourceVal
      },
      page: currentPage,
      limit: rows,
      order: {
        order: "updatedAt",
        dir: 'DESC',
      },
    };

    if (!this.isAdmin) {
      param.where.user_id = this.localStorage.getUserId();
    }

    this.leadService.getAllLeads(param).subscribe({
      next: (res: any) => {
        this.dataSource = res.rows;
        this.totalRows = res.count;
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      },
      error: () => {
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      }
    });
  }

  getLeadsByOwnership(currentPage: number, rows: number): void {
    this.isDataLoading = true;
    let selectedOwnerVal = this.selectedLeadOwnerFilter.map((owner: any) => owner.user_id);
    let param: any = {
      where: {
        organization_id: this.localStorage.getOrganizationId(),
        campus_id: this.localStorage.getCampusId(),
        user_id: selectedOwnerVal
      },
      page: currentPage,
      limit: rows,
      order: {
        order: "updatedAt",
        dir: 'DESC',
      },
    };

    if (!this.isAdmin) {
      param.where.user_id = this.localStorage.getUserId();
    }

    this.leadService.getAllLeads(param).subscribe({
      next: (res: any) => {
        this.dataSource = res.rows;
        this.totalRows = res.count;
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      },
      error: () => {
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      }
    });
  }


  getQualifiedLeads(currentPage: number, rows: number): void {
    this.isDataLoading = true;
    let param: any = {
      where: {
        organization_id: this.localStorage.getOrganizationId(),
        campus_id: this.localStorage.getCampusId(),
        lead_status: 'Qualified'
      },
      page: currentPage,
      limit: rows,
      order: {
        order: "updatedAt",
        dir: 'DESC',
      },
    };

    if (!this.isAdmin) {
      param.where.user_id = this.localStorage.getUserId();
    }

    this.leadService.getAllLeads(param).subscribe({
      next: (res: any) => {
        this.dataSource = res.rows;
        this.totalRows = res.count;
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      },
      error: () => {
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      }
    });
  }



  getCallLogReport(currentPage: number, rows: number): void {
    this.isDataLoading = true;
    let param: any = {
      "advanced_filters": {
        "calls": {
          "checked": true,
          "condition": "with"
        }
      },
      "organization_id": this.localStorage.getOrganizationId(),
      "campus_id": this.localStorage.getCampusId(),
      "where": {

      },
      "order": {
        "col": "\"lead\".\"updatedAt\"",
        "dir": "DESC"
      },
      "page": currentPage,
      "limit": rows,
      "startDate": this.startDate,
      "endDate": this.endDate
    }

    if (!this.isAdmin) {
      param.where.user_id = this.localStorage.getUserId();
    }

    if(this.selectedLeadOwnerFilter.length > 0) {
      param.user_id = this.selectedLeadOwnerFilter.map((owner: any) => owner.user_id);
    }

    this.leadService.getLeadCommunicationReport(param).subscribe({
      next: (res: any) => {
        this.dataSource = res.rows;
        this.totalRows = res.count;
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      },
      error: () => {
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      }
    });
  }


  getEmailLogReport(currentPage: number, rows: number): void {
    this.isDataLoading = true;
    let param: any = {
      "advanced_filters": {
        "emails": {
          "checked": true,
          "condition": "with"
        }
      },
      "organization_id": this.localStorage.getOrganizationId(),
      "campus_id": this.localStorage.getCampusId(),
      "where": {

      },
      "order": {
        "col": "\"lead\".\"updatedAt\"",
        "dir": "DESC"
      },
      "page": currentPage,
      "limit": rows,
      "startDate": this.startDate,
      "endDate": this.endDate
    }

    if (!this.isAdmin) {
      param.where.user_id = this.localStorage.getUserId();
    }

    if(this.selectedLeadOwnerFilter.length > 0) {
      param.user_id = this.selectedLeadOwnerFilter.map((owner: any) => owner.user_id);
    }

    this.leadService.getLeadCommunicationReport(param).subscribe({
      next: (res: any) => {
        this.dataSource = res.rows;
        this.totalRows = res.count;
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      },
      error: () => {
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      }
    });
  }

  getInitials(element: any): string {
    const name = [element.first_name, element.last_name].filter(Boolean).join(' ');
    const initials = name.split(' ').map((n: string) => n.charAt(0).toUpperCase()).join('');
    return initials.length > 2 ? initials.slice(0, 2) : initials;
  }

  getName(element: any): string {
    return [element.first_name, element.last_name].filter(Boolean).join(' ') || 'N/A';
  }

  getStatusClass(element: any): string {
    const statusMap: { [key: string]: string } = {
      'New': 'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100',
      'In Progress': 'bg-yellow-100 text-yellow-800 dark:bg-yellow-800 dark:text-yellow-100',
      'Closed': 'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100',
    };
    return statusMap[element.status] || 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-100';
  }

  getStatusDotClass(element: any): string {
    const statusDotMap: { [key: string]: string } = {
      'New': 'bg-green-500',
      'In Progress': 'bg-yellow-500',
      'Closed': 'bg-red-500',
    };
    return statusDotMap[element.status] || 'bg-gray-500';
  }



}


function observableOf(arg0: null): any {
  console.log(arg0);
  throw new Error('Function not implemented.');
}
